import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { CartProvider } from './state/cart'
import { SessionProvider } from './state/session'
import { LanguageProvider } from './i18n/LanguageContext'
import './index.css'

const container = document.getElementById('root')

if (!container) {
  throw new Error('The application root element is missing from index.html')
}

/**
 * Mounts the application.
 *
 * The order of the providers matters: the session is established before the basket is read, because a signed
 * in customer's basket lives on their account rather than on a guest identifier, and reading it first would
 * fetch the wrong one.
 */
createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <SessionProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </SessionProvider>
      </LanguageProvider>
    </BrowserRouter>
  </StrictMode>,
)
